module.exports = __webpack_public_path__ + "img/songbooklet_large.20e47b89.png";